export default function NotificationSettings(){
    return(
        <div className='ml-0 lg:ml-[256px]'>
            <div className="text-center">Notification Settings</div>
        </div>
    )
}